module.exports = {"name":"manualNotifications","audiences":["allMembers"],"experimentAllocation":0.2,"defaultWeight":1,"defaults":{"count":false,"markRead":false},"variations":[{"name":"count","weight":1,"values":{"count":true,"markRead":false}},{"name":"markRead","weight":1,"values":{"count":false,"markRead":true}},{"name":"countAndMarkRead","weight":1,"values":{"count":true,"markRead":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/manualNotifications.json
// module id = Dc7P
// module chunks = 0